import { EMPTY_FUNCTION } from '../../../../constants/common'
import { getQaSelector } from '../../../../utils/common'
import { QA_NAME_GRETA_AI_CHAT_CHAT_LIST_RESIZE } from '../../GretaAIChat.constants'
import { GretaAIChatChatList } from '../../GretaAIChatChatList'

import * as styles from './GretaAIChatChatListColumn.module.css'

function GretaAIChatChatListColumn({
  className = styles.chatListColumn,
  resizeHandleProps,
  style,
  withRowActions = true,
  onSelectChat = EMPTY_FUNCTION,
}) {
  return (
    <div className={className} style={style}>
      <GretaAIChatChatList
        className={styles.chatList}
        withRowActions={withRowActions}
        onSelectChat={onSelectChat}
      />
      {resizeHandleProps ? (
        <div
          {...resizeHandleProps}
          {...getQaSelector({ value: QA_NAME_GRETA_AI_CHAT_CHAT_LIST_RESIZE })}
          className={styles.resizeHandle}
        />
      ) : null}
    </div>
  )
}

export default GretaAIChatChatListColumn
